import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "rd-modal-container",
  class: "raise-donors"
}
const _hoisted_2 = ["aria-hidden"]
const _hoisted_3 = { class: "rd-bg-white !rd-h-auto rd-modal-content" }
const _hoisted_4 = { class: "prompt-children" }

import { computed, watch, ref, nextTick } from "vue";
import PromptComponent from "./PromptComponent.vue";
import RecurringAskPrompt from "./RecurringAskPrompt.vue";
import { PartialDisplayType, PromptType, PromptDecision, ModalDisplayType } from "../../enums";
import { AllComponents } from "@/builder/client/AllComponents";
import { useRenderStore } from "@/builder/stores/renderStore";
import { useFocusTrap } from '@vueuse/integrations/useFocusTrap';

//refs

export default /*@__PURE__*/_defineComponent({
  __name: 'PromptRenderContainer',
  setup(__props) {

_useCssVars(_ctx => ({
  "6e5d9244": (trayMaxHeight.value),
  "5f2866d4": (trayHeight.value)
}))

const prompt = ref();
const showPromptElements = ref(false);
const trayHeight = ref();
const trayMaxHeight = ref();
const showPromptContainer = ref(false);

const renderStore = useRenderStore();
const { activate, deactivate } = useFocusTrap(prompt);

const modalType = renderStore.page.pageDesign.modalDisplay;

//computed
const promptComponent = computed(() => {
    return renderStore.activePrompt;
});

const showPrompt = computed(() => {
    return !!promptComponent.value;
});

const isModalForm = computed(() => {
    return renderStore.page.partialDisplayType === PartialDisplayType.Modal;
});

const getModalAnimation = computed(() => {
    let animationClasses = '';

    if (showPromptContainer.value) {
        animationClasses = 'fade-in';
    }
    else {
        animationClasses = 'fade-out';
    }

    return animationClasses;
});

const getModalMaxHeight = computed(() => {
    let maxHeight = '';

    if (modalType == ModalDisplayType.Panel) {
        maxHeight = 'max-h-in-panel';
    }

    return maxHeight;
});

//methods
const closePrompt = () => {
    if (promptComponent.value) {
        renderStore.resolvePrompt(promptComponent.value?.id, PromptDecision.Decline);
    }

    if (!isModalForm.value) {
        document.body.classList.remove('rd-modal-open');
    }

    showPromptContainer.value = false;

    setTimeout(() => {
        showPromptElements.value = false;
        deactivate();
    }, 500);
};

const openPrompt = () => {
    showPromptElements.value = true;
    showPromptContainer.value = true;

    isModalForm.value ?
        prompt.value?.classList.add('tray-open') :
        document.body.classList.add('rd-modal-open');

    if (isModalForm.value) {
        nextTick(() => {
            modalType == ModalDisplayType.Panel ?
                trayMaxHeight.value = (prompt.value.offsetParent.offsetHeight - 30) + 'px' :
                trayMaxHeight.value = '700px';
        });
    }

    setTimeout(() => {
        activate();
    }, 275);
};

const onAfterEnter = () => {
    prompt.value?.classList.add('tray-open');

    if (modalType == ModalDisplayType.Lightbox) {
        prompt.value.offsetHeight < 690 ?
            trayHeight.value = prompt.value.offsetHeight + 'px' :
            trayHeight.value = '100%';
    }
    else {
        trayHeight.value = prompt.value.offsetHeight + 'px';
    }
};

const onLeave = () => {
    prompt.value?.classList.add('tray-close');
};

//watchers
watch(showPrompt, (val) => {
    if (val) {
        openPrompt();
    }
    else {
        closePrompt();
    }
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isModalForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["rd-h-full rd-left-0 rd-overflow-x-hidden rd-overflow-y-auto rd-fixed rd-top-0 rd-w-full rd-modal", showPromptContainer.value ? 'rd-block' : 'rd-hidden']),
            id: "rd-modal",
            tabindex: "-1",
            role: "dialog",
            "aria-label": "Prompt Modal",
            "aria-hidden": showPromptContainer.value ? false : true,
            ref_key: "prompt",
            ref: prompt,
            onClick: _withModifiers(closePrompt, ["stop"])
          }, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              class: _normalizeClass(["rd-items-center rd-flex rd-pointer-events-none rd-relative rd-w-auto rd-modal-wrapper rd-modal-scroll rd-modal-centered md:rd-modal-full rd-modal-prompt", getModalAnimation.value]),
              role: "document"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(PromptComponent, null, {
                  children: _withCtx(() => [
                    _createElementVNode("section", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promptComponent.value?.components, (item) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[item.type]), {
                          key: item.id,
                          component: item
                        }, null, 8, ["component"]))
                      }), 128))
                    ])
                  ]),
                  content: _withCtx(() => [
                    (promptComponent.value?.promptType === _unref(PromptType).RecurringAsk)
                      ? (_openBlock(), _createBlock(RecurringAskPrompt, {
                          key: 0,
                          class: "prompt-children",
                          component: promptComponent.value
                        }, null, 8, ["component"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ], 2)
          ], 10, _hoisted_2),
          _createElementVNode("div", {
            class: _normalizeClass(["rd-modal-backdrop", [(showPromptContainer.value) ? 'fade-in-backdrop' : 'fade-out-backdrop', { 'rd-hidden': !showPromptElements.value }]])
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    (isModalForm.value && showPromptContainer.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["tray-overlay", [showPromptContainer.value ? 'fade-in-backdrop-fast' : 'fade-out-backdrop-fast']])
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "tray",
      onAfterEnter: onAfterEnter,
      onLeave: onLeave
    }, {
      default: _withCtx(() => [
        (isModalForm.value && showPrompt.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "tray",
              ref_key: "prompt",
              ref: prompt,
              class: "tray"
            }, [
              _createVNode(PromptComponent, {
                class: _normalizeClass(["rd-items-center rd-flex rd-flex-col rd-h-full rd-w-full", getModalMaxHeight.value])
              }, {
                children: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promptComponent.value?.components, (item) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[item.type]), {
                      key: item.id,
                      component: item
                    }, null, 8, ["component"]))
                  }), 128))
                ]),
                content: _withCtx(() => [
                  (promptComponent.value?.promptType === _unref(PromptType).RecurringAsk)
                    ? (_openBlock(), _createBlock(RecurringAskPrompt, {
                        key: 0,
                        class: "rd-w-full",
                        component: promptComponent.value
                      }, null, 8, ["component"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ])), [
              [_directive_click_outside, closePrompt]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})